<template>
  <div>
    <LocationTab
        :items="items"
        :columns="columns"
        :isCalled="isCalled"
        :captionTab="captiontable"
        :selectedValue="selectedItem"
        @editItem="showEditDialog"
        v-model="selectedItem"
        :captionSpr="captionLocation"
        :urls="urls"
        ref="LocationTab"
        :stacked="stacked"
    >
    </LocationTab>

    <b-modal ref="editModal" v-model="modalEditOpened" title="Редактирование объекта спорта" size="lg" hide-footer id="editModal">
      <div class="d-block">

        <b-input-group prepend="Наименование" class="mt-1" size="sm">
          <b-form-input type="email" v-model="selectedItem.nameObj" placeholder="Укажите наименование"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.nameObj">не указано наименование</b-form-invalid-feedback>

        <b-input-group prepend="Населенный пункт" class="mt-1" size="sm">
          <b-form-input type="email" v-model="selectedItem.locality" placeholder="Укажите населенный пункт"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.locality">не указан населенный пункт</b-form-invalid-feedback>

        <b-input-group prepend="Район" class="mt-1" size="sm">
          <b-form-input type="email" v-model="selectedItem.district" placeholder="Укажите район"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.district">не указан район</b-form-invalid-feedback>

        <b-input-group prepend="Адрес" class="mt-1" size="sm">
          <b-form-input type="email" v-model="selectedItem.adress" placeholder="Укажите адрес"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.adress">не указан адрес</b-form-invalid-feedback>

        <b-input-group prepend="Телефон" class="mt-1" size="sm">
          <b-input-group-append>
            <the-mask class="px-1" style="width: 100%" type="text"
                      :mask="['+7 (###) ###-####', '+7 (###) ###-####']"
                      v-model="selectedItem.phoneNumber"
                      placeholder="+7(999) 999-9999"/>
          </b-input-group-append>
        </b-input-group>

        <b-form-checkbox v-model="selectedItem.city" style="font-size: 10px">Город</b-form-checkbox>
        <b-form-checkbox v-model="selectedItem.capital" style="font-size: 10px">Столица</b-form-checkbox>

      </div>
      <div class="text-right">
        <b-button class="mt-2 mr-1" variant="outline-primary" @click="saveLocationPlace">Сохранить</b-button>
        <b-button class="mt-2" variant="outline-danger" @click="modalEditOpened=!modalEditOpened">Отменить</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import LocationTab from '@/components/TabSpr.vue'
import http from '@/http-common'

export default {
  name: "PeopleList",
  components: {LocationTab},
  props: {
    isCalled: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [
        {key: 'nameObj', label: 'Наименование объекта'},
        {key: 'locality', label: 'Населенный пункт'},
        {key: 'district', label: 'Район'},
        {key: 'adress', label: 'Адрес'},
        {key: 'phoneTel', label: 'Телефон'},
        {key: 'capital', label: 'Столица'},
        {key: 'city', label: 'Город'},
        {key: 'edit_field', label: '', class: 'width10'}
      ],
    }
  },
  data() {
    return {
      items: [],
      captiontable: 'Объекты спорта',
      captionLocation: {
        name: 'Место проведения',
        nameR: 'место проведения'
      },
      urls: {
        save: '/location/save',
        delete: '/location/delete',
      },
      modalEditOpened: false,
      selectedItem: {},
      validValue: {
        nameObj: true,
        locality: true,
        district: true,
        adress: true,
        form: true
      },
      stacked: {
        flg: false,
        size: 'md'
      },
    }
  },
  created() {
    this.loadItems()
  },
  methods: {
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (!this.selectedItem.nameObj || this.selectedItem.nameObj === '') {
        this.validValue.nameObj = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.locality || this.selectedItem.locality === '') {
        this.validValue.locality = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.district || this.selectedItem.district === '') {
        this.validValue.district = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.adress || this.selectedItem.adress === '') {
        this.validValue.adress = false;
        this.validValue.form = false;
      }
    },
    loadItems() {
      var vm = this;
      http.get('/location/list')
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.response.data));
    },
    rowSelected(items) {
      this.selected = items;
      for (var key in items[0]) {
        this.selectedItem[key] = items[0][key];
      }
      this.$emit('input', this.selectedItem)
    },
    showEditDialog() {
      if (this.isCalled && this.selectedItem.id > 0) {
        this.rowSelected([this.selectedItem]);
        this.$emit('selectItem')
      } else {
        this.modalEditOpened = !this.modalEditOpened;
      }
    },
    saveLocationPlace() {
      this.checkForm();
      if (this.validValue.form) {
        this.modalEditOpened = false;
        this.$refs.LocationTab.save(this.selectedItem);
      }

    }
  }
}
</script>
